const SupportedCurrencies = ["BRL"];

const PaymentIntentSchema = {
    type: "object",
    additionalProperties: false,
    required: ["companyId", "amount", "currency"],
    properties: {
        companyId: { type: "string", format: "uuid" },
        personId: { type: "string", format: "uuid" },
        gatewayPaymentIntentId: { type: "string" },
        captureMethod: { type: "string" },
        orderId: { type: "string" },
        amount: { type: "number" },
        currency: { enum: SupportedCurrencies },
        status: { enum: ["pending", "paid", "canceled", "failed"] },
        metadata: { type: "object" },
    },
};

module.exports = {
    PaymentIntentSchema,
};
